export const finalCtaStyles = Object.freeze({
  section: "studio-landing-final-cta-section",
  ctaStage: "studio-landing-final-cta-ctaStage",
  heading: "studio-landing-final-cta-heading",
  formCloud: "studio-landing-final-cta-formCloud",
  entryPanel: "studio-landing-final-cta-entryPanel",
  entryIntro: "studio-landing-final-cta-entryIntro",
  entryActions: "studio-landing-final-cta-entryActions",
  entryPrimary: "studio-landing-final-cta-entryPrimary",
  entrySecondary: "studio-landing-final-cta-entrySecondary",
  entryPending: "studio-landing-final-cta-entryPending",
  footer: "studio-landing-final-cta-footer",
  footerContent: "studio-landing-final-cta-footerContent",
  footerTop: "studio-landing-final-cta-footerTop",
  identity: "studio-landing-final-cta-identity",
  brand: "studio-landing-final-cta-brand",
  aiSummary: "studio-landing-final-cta-aiSummary",
  aiStatus: "studio-landing-final-cta-aiStatus",
  aiProviders: "studio-landing-final-cta-aiProviders",
  aiProvider: "studio-landing-final-cta-aiProvider",
  footerCta: "studio-landing-final-cta-footerCta",
  linkGrid: "studio-landing-final-cta-linkGrid",
  linkGroup: "studio-landing-final-cta-linkGroup",
  wordmark: "studio-landing-final-cta-wordmark",
  legalRow: "studio-landing-final-cta-legalRow",
});

export const contactStyles = Object.freeze({
  section: "studio-landing-contact",
  canvas: "studio-landing-contact-canvas",
  scrim: "studio-landing-contact-scrim",
  content: "studio-landing-contact-content",
  eyebrow: "studio-landing-contact-eyebrow",
  description: "studio-landing-contact-description",
  links: "studio-landing-contact-links",
  link: "studio-landing-contact-link",
  xMark: "studio-landing-contact-xMark",
  corner: "studio-landing-contact-corner",
  qrModal: "studio-landing-contact-qrModal",
  qrCard: "studio-landing-contact-qrCard",
  qrClose: "studio-landing-contact-qrClose",
  qrEyebrow: "studio-landing-contact-qrEyebrow",
  qrImage: "studio-landing-contact-qrImage",
  qrHint: "studio-landing-contact-qrHint",
});

export const introHeroStyles = Object.freeze({
  airHeader: "studio-landing-intro-airHeader",
  airHero: "studio-landing-intro-airHero",
  headerBar: "studio-landing-intro-headerBar",
  headerLeft: "studio-landing-intro-headerLeft",
  headerActions: "studio-landing-intro-headerActions",
  resourcesTrigger: "studio-landing-intro-resourcesTrigger",
  loginLink: "studio-landing-intro-loginLink",
  languageButton: "studio-landing-intro-languageButton",
  headerWordmark: "studio-landing-intro-headerWordmark",
  headerCta: "studio-landing-intro-headerCta",
  drawerToggle: "studio-landing-intro-drawerToggle",
  menuBackdrop: "studio-landing-intro-menuBackdrop",
  resourcesMenu: "studio-landing-intro-resourcesMenu",
  resourcesLinks: "studio-landing-intro-resourcesLinks",
  resourcesHeading: "studio-landing-intro-resourcesHeading",
  resourceGrid: "studio-landing-intro-resourceGrid",
  resourceIcon: "studio-landing-intro-resourceIcon",
  resourceArrow: "studio-landing-intro-resourceArrow",
  resourceFeature: "studio-landing-intro-resourceFeature",
  featureVisual: "studio-landing-intro-featureVisual",
  featureVideo: "studio-landing-intro-featureVideo",
  featureNote: "studio-landing-intro-featureNote",
  mobileDrawer: "studio-landing-intro-mobileDrawer",
  introSpacer: "studio-landing-intro-introSpacer",
  heroInner: "studio-landing-intro-heroInner",
  heroCopy: "studio-landing-intro-heroCopy",
  rotatingLine: "studio-landing-intro-rotatingLine",
  rotatingLead: "studio-landing-intro-rotatingLead",
  kineticSlogan: "studio-landing-intro-kineticSlogan",
  sloganVisual: "studio-landing-intro-sloganVisual",
  sloganLead: "studio-landing-intro-sloganLead",
  sloganViewport: "studio-landing-intro-sloganViewport",
  sloganTrack: "studio-landing-intro-sloganTrack",
  sloganPhrase: "studio-landing-intro-sloganPhrase",
  sloganInlineTail: "studio-landing-intro-sloganInlineTail",
  sloganTail: "studio-landing-intro-sloganTail",
  brandInput: "studio-landing-intro-brandInput",
  srOnly: "studio-landing-intro-srOnly",
  heroError: "studio-landing-intro-heroError",
  shortcutRow: "studio-landing-intro-shortcutRow",
  watchLink: "studio-landing-intro-watchLink",
  heroActions: "studio-landing-intro-heroActions",
  primaryAction: "studio-landing-intro-primaryAction",
  secondaryAction: "studio-landing-intro-secondaryAction",
  prompt: "studio-landing-intro-prompt",
  promptMask: "studio-landing-intro-promptMask",
  capabilityGrid: "studio-landing-intro-capabilityGrid",
  capabilityCard: "studio-landing-intro-capabilityCard",
  capabilityVisual: "studio-landing-intro-capabilityVisual",
  decodeVisual: "studio-landing-intro-decodeVisual",
  discoverVisual: "studio-landing-intro-discoverVisual",
  velocity: "studio-landing-intro-velocity",
  searchChip: "studio-landing-intro-searchChip",
  shootReady: "studio-landing-intro-shootReady",
  videoFrames: "studio-landing-intro-videoFrames",
  playIcon: "studio-landing-intro-playIcon",
  timeline: "studio-landing-intro-timeline",
  createVisual: "studio-landing-intro-createVisual",
  scriptSheet: "studio-landing-intro-scriptSheet",
  mobileResourceList: "studio-landing-intro-mobileResourceList",
  mobileViewAll: "studio-landing-intro-mobileViewAll",
  mobileDrawerActions: "studio-landing-intro-mobileDrawerActions",
  inviteBackdrop: "studio-landing-intro-inviteBackdrop",
  inviteCard: "studio-landing-intro-inviteCard",
  inviteClose: "studio-landing-intro-inviteClose",
  inviteHint: "studio-landing-intro-inviteHint",
  inviteImage: "studio-landing-intro-inviteImage",
  inviteX: "studio-landing-intro-inviteX",
  inviteActions: "studio-landing-intro-inviteActions",
  invitePrimary: "studio-landing-intro-invitePrimary",
  inviteSecondary: "studio-landing-intro-inviteSecondary",
});

export const narrativeStyles = Object.freeze({
  narrative: "studio-landing-narrative-narrative",
  section: "studio-landing-narrative-section",
  useCases: "studio-landing-narrative-useCases",
  comparisonProof: "studio-landing-narrative-comparisonProof",
  faq: "studio-landing-narrative-faq",
  problem: "studio-landing-narrative-problem",
  problemLines: "studio-landing-narrative-problemLines",
  problemAnswer: "studio-landing-narrative-problemAnswer",
  centerHeader: "studio-landing-narrative-centerHeader",
  splitHeader: "studio-landing-narrative-splitHeader",
  contextLayout: "studio-landing-narrative-contextLayout",
  tabColumn: "studio-landing-narrative-tabColumn",
  contextProduct: "studio-landing-narrative-contextProduct",
  contextDocument: "studio-landing-narrative-contextDocument",
  contextScore: "studio-landing-narrative-contextScore",
  factRows: "studio-landing-narrative-factRows",
  statement: "studio-landing-narrative-statement",
  agentStage: "studio-landing-narrative-agentStage",
  agentWorkspace: "studio-landing-narrative-agentWorkspace",
  agentConversation: "studio-landing-narrative-agentConversation",
  agentBrief: "studio-landing-narrative-agentBrief",
  agentResult: "studio-landing-narrative-agentResult",
  handoff: "studio-landing-narrative-handoff",
  workflowLayout: "studio-landing-narrative-workflowLayout",
  workflowSteps: "studio-landing-narrative-workflowSteps",
  workflowSticky: "studio-landing-narrative-workflowSticky",
  workflowProduct: "studio-landing-narrative-workflowProduct",
  workflowMeta: "studio-landing-narrative-workflowMeta",
  workflowCanvas: "studio-landing-narrative-workflowCanvas",
  useCaseGrid: "studio-landing-narrative-useCaseGrid",
  useCase: "studio-landing-narrative-useCase",
  comparisonIntro: "studio-landing-narrative-comparisonIntro",
  comparison: "studio-landing-narrative-comparison",
  comparisonHead: "studio-landing-narrative-comparisonHead",
  comparisonRow: "studio-landing-narrative-comparisonRow",
  faqList: "studio-landing-narrative-faqList",
  journeyBridge: "studio-landing-narrative-journeyBridge",
  workflowOuter: "studio-landing-narrative-workflowOuter",
  workflowExperience: "studio-landing-narrative-workflowExperience",
  workflowHeader: "studio-landing-narrative-workflowHeader",
  workflowProgress: "studio-landing-narrative-workflowProgress",
  workflowMobile: "studio-landing-narrative-workflowMobile",
  mobileStage: "studio-landing-narrative-mobileStage",
  beforeAfter: "studio-landing-narrative-beforeAfter",
  contextItems: "studio-landing-narrative-contextItems",
  pmBar: "studio-landing-narrative-pmBar",
  agentChips: "studio-landing-narrative-agentChips",
  outputList: "studio-landing-narrative-outputList",
  problemStory: "studio-landing-narrative-problemStory",
  problemSequence: "studio-landing-narrative-problemSequence",
  problemSticky: "studio-landing-narrative-problemSticky",
  problemKicker: "studio-landing-narrative-problemKicker",
  problemStage: "studio-landing-narrative-problemStage",
  problemBeat: "studio-landing-narrative-problemBeat",
  problemTicks: "studio-landing-narrative-problemTicks",
  problemResolution: "studio-landing-narrative-problemResolution",
  problemSrOnly: "studio-landing-narrative-problemSrOnly",
  problemStatic: "studio-landing-narrative-problemStatic",
});

export const trustStyles = Object.freeze({
  outer: "studio-landing-trust-outer",
  inner: "studio-landing-trust-inner",
  header: "studio-landing-trust-header",
  communityProof: "studio-landing-trust-communityProof",
  thanks: "studio-landing-trust-thanks",
  wall: "studio-landing-trust-wall",
  row: "studio-landing-trust-row",
  track: "studio-landing-trust-track",
  group: "studio-landing-trust-group",
  trackForward: "studio-landing-trust-trackForward",
  trackReverse: "studio-landing-trust-trackReverse",
  card: "studio-landing-trust-card",
  compact: "studio-landing-trust-compact",
  feature: "studio-landing-trust-feature",
  standard: "studio-landing-trust-standard",
  placeholder: "studio-landing-trust-placeholder",
});

export const sceneStyles = Object.freeze({
  scene: "studio-landing-scene-scene",
  toneRail: "studio-landing-scene-toneRail",
  toneButton: "studio-landing-scene-toneButton",
});

export const writingStyles = Object.freeze({
  intro: "studio-landing-writing-intro",
  stroke: "studio-landing-writing-stroke",
  dot: "studio-landing-writing-dot",
  wordmark: "studio-landing-writing-wordmark",
  finishedWordmark: "studio-landing-writing-finishedWordmark",
});

export const landingStyles = Object.freeze({
  page: "studio-landing-page",
  content: "studio-landing-content",
});

export const resourceStyles = Object.freeze({
  page: "studio-resources-page",
  pageHero: "studio-resources-pageHero",
  heroMark: "studio-resources-heroMark",
  utility: "studio-resources-utility",
  sky: "studio-resources-sky",
  editorial: "studio-resources-editorial",
  blue: "studio-resources-blue",
  pink: "studio-resources-pink",
  lime: "studio-resources-lime",
  ink: "studio-resources-ink",
  featuredResource: "studio-resources-featuredResource",
  featuredVisual: "studio-resources-featuredVisual",
  videoFrame: "studio-resources-videoFrame",
  analysisCard: "studio-resources-analysisCard",
  featuredCopy: "studio-resources-featuredCopy",
  resourceDirectory: "studio-resources-resourceDirectory",
  resourceGroup: "studio-resources-resourceGroup",
  blogSection: "studio-resources-blogSection",
  filters: "studio-resources-filters",
  activeFilter: "studio-resources-activeFilter",
  postGrid: "studio-resources-postGrid",
  postCard: "studio-resources-postCard",
  leadPost: "studio-resources-leadPost",
  postArtwork: "studio-resources-postArtwork",
  postCopy: "studio-resources-postCopy",
  detailIntro: "studio-resources-detailIntro",
  detailGrid: "studio-resources-detailGrid",
  detailList: "studio-resources-detailList",
  detailAside: "studio-resources-detailAside",
  bottomCta: "studio-resources-bottomCta",
  footer: "studio-resources-footer",
  footerBrand: "studio-resources-footerBrand",
});

export const blogStyles = Object.freeze({
  page: "studio-blog-page",
  intro: "studio-blog-intro",
  introCopy: "studio-blog-introCopy",
  heroFilters: "studio-blog-heroFilters",
  count: "studio-blog-count",
  directoryHeader: "studio-blog-directoryHeader",
  directory: "studio-blog-directory",
  directoryHeading: "studio-blog-directoryHeading",
  filters: "studio-blog-filters",
  activeFilter: "studio-blog-activeFilter",
  filterIndicator: "studio-blog-filterIndicator",
  directoryContent: "studio-blog-directoryContent",
  grid: "studio-blog-grid",
  gridItem: "studio-blog-gridItem",
  card: "studio-blog-card",
  featured: "studio-blog-featured",
  cardMedia: "studio-blog-cardMedia",
  cardCopy: "studio-blog-cardCopy",
  cardCategory: "studio-blog-cardCategory",
  cardExcerpt: "studio-blog-cardExcerpt",
  cardMeta: "studio-blog-cardMeta",
  cardAction: "studio-blog-cardAction",
  loadMore: "studio-blog-loadMore",
  empty: "studio-blog-empty",
  closingCta: "studio-blog-closingCta",
  closingCtaInner: "studio-blog-closingCtaInner",
  closingCtaAction: "studio-blog-closingCtaAction",
  skyBridge: "studio-blog-skyBridge",
  article: "studio-blog-article",
  articleHero: "studio-blog-articleHero",
  articleMasthead: "studio-blog-articleMasthead",
  backLink: "studio-blog-backLink",
  articleMeta: "studio-blog-articleMeta",
  articleTags: "studio-blog-articleTags",
  articleCover: "studio-blog-articleCover",
  articleReading: "studio-blog-articleReading",
  articleBody: "studio-blog-articleBody",
  articleToc: "studio-blog-articleToc",
  articleTocDesktop: "studio-blog-articleTocDesktop",
  articleTocMobile: "studio-blog-articleTocMobile",
  articleTocList: "studio-blog-articleTocList",
  related: "studio-blog-related",
  relatedHeader: "studio-blog-relatedHeader",
});

export const marketingStyles = Object.freeze({
  page: "studio-marketing-page",
  hero: "studio-marketing-hero",
  sky: "studio-marketing-sky",
  editorial: "studio-marketing-editorial",
  utility: "studio-marketing-utility",
  productLead: "studio-marketing-productLead",
  preview: "studio-marketing-preview",
  detailLayout: "studio-marketing-detailLayout",
  detailList: "studio-marketing-detailList",
  collection: "studio-marketing-collection",
  collectionDisabled: "studio-marketing-collectionDisabled",
  ctaBand: "studio-marketing-ctaBand",
  siteFooter: "studio-marketing-siteFooter",
  footerBrand: "studio-marketing-footerBrand",
  formSection: "studio-marketing-formSection",
  leadForm: "studio-marketing-leadForm",
  formSuccess: "studio-marketing-formSuccess",
  fieldPair: "studio-marketing-fieldPair",
  formSubmit: "studio-marketing-formSubmit",
  formError: "studio-marketing-formError",
  collectionLead: "studio-marketing-collectionLead",
});

export const toolStyles = Object.freeze({
  toolPreview: "studio-tool-toolPreview",
  previewNotice: "studio-tool-previewNotice",
  liveStatus: "studio-tool-liveStatus",
  workspace: "studio-tool-workspace",
  controlRail: "studio-tool-controlRail",
  panelLabel: "studio-tool-panelLabel",
  choiceList: "studio-tool-choiceList",
  creatorList: "studio-tool-creatorList",
  primaryAction: "studio-tool-primaryAction",
  secondaryAction: "studio-tool-secondaryAction",
  resultPanel: "studio-tool-resultPanel",
  briefOutput: "studio-tool-briefOutput",
  fitPanel: "studio-tool-fitPanel",
  isLoading: "studio-tool-isLoading",
  rankList: "studio-tool-rankList",
  videoWorkspace: "studio-tool-videoWorkspace",
  videoFrame: "studio-tool-videoFrame",
  frameTime: "studio-tool-frameTime",
  frameSubject: "studio-tool-frameSubject",
  momentPanel: "studio-tool-momentPanel",
  timeline: "studio-tool-timeline",
  scoreList: "studio-tool-scoreList",
});

export const imageGeneratorStyles = Object.freeze({
  page: "studio-imagegen-page",
  workspace: "studio-imagegen-workspace",
  rail: "studio-imagegen-rail",
  railHeading: "studio-imagegen-railHeading",
  railAction: "studio-imagegen-railAction",
  railSection: "studio-imagegen-railSection",
  railItem: "studio-imagegen-railItem",
  railMeta: "studio-imagegen-railMeta",
  main: "studio-imagegen-main",
  mobileToolbar: "studio-imagegen-mobileToolbar",
  stage: "studio-imagegen-stage",
  stageHeader: "studio-imagegen-stageHeader",
  eyebrow: "studio-imagegen-eyebrow",
  templateGrid: "studio-imagegen-templateGrid",
  templateCard: "studio-imagegen-templateCard",
  templateMedia: "studio-imagegen-templateMedia",
  templateTag: "studio-imagegen-templateTag",
  templateTry: "studio-imagegen-templateTry",
  templateCopy: "studio-imagegen-templateCopy",
  resultGrid: "studio-imagegen-resultGrid",
  resultCard: "studio-imagegen-resultCard",
  resultMedia: "studio-imagegen-resultMedia",
  resultMeta: "studio-imagegen-resultMeta",
  generating: "studio-imagegen-generating",
  composerDock: "studio-imagegen-composerDock",
  composer: "studio-imagegen-composer",
  promptRow: "studio-imagegen-promptRow",
  upload: "studio-imagegen-upload",
  attachmentSurface: "studio-imagegen-attachmentSurface",
  attachmentTray: "studio-imagegen-attachmentTray",
  attachmentTrayExpanded: "studio-imagegen-attachmentTrayExpanded",
  attachmentList: "studio-imagegen-attachmentList",
  attachmentPosition: "studio-imagegen-attachmentPosition",
  attachmentCard: "studio-imagegen-attachmentCard",
  attachmentMedia: "studio-imagegen-attachmentMedia",
  attachmentTooltip: "studio-imagegen-attachmentTooltip",
  attachmentAdd: "studio-imagegen-attachmentAdd",
  uploadRemove: "studio-imagegen-uploadRemove",
  attachmentError: "studio-imagegen-attachmentError",
  previewBackdrop: "studio-imagegen-previewBackdrop",
  previewDialog: "studio-imagegen-previewDialog",
  previewStage: "studio-imagegen-previewStage",
  previewClose: "studio-imagegen-previewClose",
  previewNav: "studio-imagegen-previewNav",
  previewPrevious: "studio-imagegen-previewPrevious",
  previewNext: "studio-imagegen-previewNext",
  previewMeta: "studio-imagegen-previewMeta",
  textarea: "studio-imagegen-textarea",
  composerControls: "studio-imagegen-composerControls",
  controlGroup: "studio-imagegen-controlGroup",
  controlAnchor: "studio-imagegen-controlAnchor",
  control: "studio-imagegen-control",
  controlActive: "studio-imagegen-controlActive",
  settingsTrigger: "studio-imagegen-settingsTrigger",
  generationPanel: "studio-imagegen-generationPanel",
  settingsField: "studio-imagegen-settingsField",
  ratioField: "studio-imagegen-ratioField",
  ratioFieldCustom: "studio-imagegen-ratioFieldCustom",
  customSizeField: "studio-imagegen-customSizeField",
  settingRail: "studio-imagegen-settingRail",
  ratioRail: "studio-imagegen-ratioRail",
  ratioGrid: "studio-imagegen-ratioGrid",
  ratioOption: "studio-imagegen-ratioOption",
  ratioGlyph: "studio-imagegen-ratioGlyph",
  autoGlyph: "studio-imagegen-autoGlyph",
  resolutionRail: "studio-imagegen-resolutionRail",
  countRail: "studio-imagegen-countRail",
  qualityRail: "studio-imagegen-qualityRail",
  dimensionRow: "studio-imagegen-dimensionRow",
  linkedControl: "studio-imagegen-linkedControl",
  bottomSettings: "studio-imagegen-bottomSettings",
  priceHelp: "studio-imagegen-priceHelp",
  vipBadge: "studio-imagegen-vipBadge",
  subjectTrigger: "studio-imagegen-subjectTrigger",
  subjectPanel: "studio-imagegen-subjectPanel",
  subjectTitle: "studio-imagegen-subjectTitle",
  subjectCreate: "studio-imagegen-subjectCreate",
  subjectOption: "studio-imagegen-subjectOption",
  subjectThumb: "studio-imagegen-subjectThumb",
  subjectEmpty: "studio-imagegen-subjectEmpty",
  cost: "studio-imagegen-cost",
  generate: "studio-imagegen-generate",
  popover: "studio-imagegen-popover",
  settings: "studio-imagegen-settings",
  settingsGroup: "studio-imagegen-settingsGroup",
  settingsOptions: "studio-imagegen-settingsOptions",
  option: "studio-imagegen-option",
  drawerBackdrop: "studio-imagegen-drawerBackdrop",
  drawer: "studio-imagegen-drawer",
  drawerHeader: "studio-imagegen-drawerHeader",
  assetGrid: "studio-imagegen-assetGrid",
  emptyAssets: "studio-imagegen-emptyAssets",
  srOnly: "studio-imagegen-srOnly",
});

export const siteHeaderStyles = Object.freeze({
  header: "studio-site-header-header",
  dark: "studio-site-header-dark",
  bar: "studio-site-header-bar",
  light: "studio-site-header-light",
  wordmark: "studio-site-header-wordmark",
  desktopNav: "studio-site-header-desktopNav",
  resourceTrigger: "studio-site-header-resourceTrigger",
  actions: "studio-site-header-actions",
  localeButton: "studio-site-header-localeButton",
  cta: "studio-site-header-cta",
  mobileToggle: "studio-site-header-mobileToggle",
  megaBackdrop: "studio-site-header-megaBackdrop",
  megaBackdropOpen: "studio-site-header-megaBackdropOpen",
  megaMenu: "studio-site-header-megaMenu",
  megaMenuOpen: "studio-site-header-megaMenuOpen",
  megaLinks: "studio-site-header-megaLinks",
  megaHeading: "studio-site-header-megaHeading",
  megaList: "studio-site-header-megaList",
  iconTile: "studio-site-header-iconTile",
  itemArrow: "studio-site-header-itemArrow",
  feature: "studio-site-header-feature",
  featureArtwork: "studio-site-header-featureArtwork",
  signalOne: "studio-site-header-signalOne",
  signalTwo: "studio-site-header-signalTwo",
  signalThree: "studio-site-header-signalThree",
  featureFrame: "studio-site-header-featureFrame",
  mobileDrawer: "studio-site-header-mobileDrawer",
  mobileDrawerOpen: "studio-site-header-mobileDrawerOpen",
  caretOpen: "studio-site-header-caretOpen",
  mobileResources: "studio-site-header-mobileResources",
  mobileResourcesOpen: "studio-site-header-mobileResourcesOpen",
  viewAllMobile: "studio-site-header-viewAllMobile",
  mobileActions: "studio-site-header-mobileActions",
});

export const headerStyles = Object.freeze({
  header: "studio-header-header",
  bar: "studio-header-bar",
  site: "studio-header-site",
  air: "studio-header-air",
  light: "studio-header-light",
  dark: "studio-header-dark",
  desktopNav: "studio-header-desktopNav",
  actions: "studio-header-actions",
  themeControl: "studio-header-themeControl",
  themeToggle: "studio-header-themeToggle",
  themeOptions: "studio-header-themeOptions",
  menuTrigger: "studio-header-menuTrigger",
  languageButton: "studio-header-languageButton",
  wordmark: "studio-header-wordmark",
  pending: "studio-header-pending",
  pendingAccount: "studio-header-pendingAccount",
  pendingSignUp: "studio-header-pendingSignUp",
  cta: "studio-header-cta",
  drawerToggle: "studio-header-drawerToggle",
  backdrop: "studio-header-backdrop",
  megaMenu: "studio-header-megaMenu",
  megaContent: "studio-header-megaContent",
  menuLinks: "studio-header-menuLinks",
  menuHeading: "studio-header-menuHeading",
  menuGrid: "studio-header-menuGrid",
  itemIcon: "studio-header-itemIcon",
  itemArrow: "studio-header-itemArrow",
  disabledItem: "studio-header-disabledItem",
  mobileDrawer: "studio-header-mobileDrawer",
  mobileSection: "studio-header-mobileSection",
  mobileDirect: "studio-header-mobileDirect",
  mobileList: "studio-header-mobileList",
  mobileDisabledItem: "studio-header-mobileDisabledItem",
  mobileViewAll: "studio-header-mobileViewAll",
  mobileActions: "studio-header-mobileActions",
});

export const uiStyles = Object.freeze({
  button: "studio-ui-button",
  solid: "studio-ui-solid",
  outline: "studio-ui-outline",
  light: "studio-ui-light",
  segmented: "studio-ui-segmented",
  segmentIndicator: "studio-ui-segmentIndicator",
  mask: "studio-ui-mask",
  productStage: "studio-ui-productStage",
  windowDots: "studio-ui-windowDots",
  status: "studio-ui-status",
  stageBody: "studio-ui-stageBody",
});
